import { getSortedI18nNamespaces } from '@/lib/i18n/get-sorted-I18n-namespaces';

const i18nNamespaces = getSortedI18nNamespaces([
  'common',
  'contact',
  'home',
  'navigation',
  'projects',
]);

export type HomeConfig = {
  i18nNamespaces: typeof i18nNamespaces;
};

export const homeConfig: HomeConfig = {
  i18nNamespaces,
};
